export const TABLE_WRAPPER_CLASS_NAME = 'richtext-table-wrapper';
export const RICHTEXT_CONTENT_CLASS_SELECTOR = '.richtext-content';
